module.exports = __webpack_public_path__ + "img/lojaintegrada.4e1cd650.svg";